import { render, staticRenderFns } from "./examList.vue?vue&type=template&id=3022d8fa&scoped=true&"
import script from "./examList.vue?vue&type=script&lang=js&"
export * from "./examList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3022d8fa",
  null
  
)

export default component.exports